import { render, staticRenderFns } from "./Candle.vue?vue&type=template&id=315047fe"
import script from "./Candle.vue?vue&type=script&lang=js"
export * from "./Candle.vue?vue&type=script&lang=js"
import style0 from "./Candle.vue?vue&type=style&index=0&id=315047fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports